import { messaging, getToken, onMessage } from "./firebase";
import { MessagePayload } from "firebase/messaging";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { GoogleAuth } from "google-auth-library";

const VAPID_KEY = "BCNuzSW38ZItF5VF9RHJMH8UqtPpFwXGSYvI-ZXxHaodAvlsgjmodJI3058YRT2NYKdt4xT4zbv4MiRNyMfXFJk"; // From Firebase Console

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, { vapidKey: VAPID_KEY });
      // console.log("FCM Token:", token);
      return token; // You can send this token to your backend for future notifications
    } else {
      console.warn("Push notifications permission denied.");
    }
  } catch (error) {
    console.error("Error getting permission:", error);
  }
};

export const onMessageListener = () =>
    new Promise<MessagePayload>((resolve) => {
      onMessage(messaging, (payload) => {
        // console.log("Message received:", payload);
        resolve(payload);
      });
    });
